module.exports = __webpack_public_path__ + "img/1570894097.fc9efa22.jpg";